import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeBlockClientTestimonialSkeleton } from './TypeBlockClientTestimonial';
import type { TypeButtonSkeleton } from './TypeButton';
import type { TypeCompanyTopicSkeleton } from './TypeCompanyTopic';
import type { TypeIndustrySkeleton } from './TypeIndustry';
import type { TypePageCaseStudySkeleton } from './TypePageCaseStudy';
import type { TypePageJournalSkeleton } from './TypePageJournal';
import type { TypeServiceSkeleton } from './TypeService';
import type { TypeSolutionSkeleton } from './TypeSolution';
import type { TypeTechnologySkeleton } from './TypeTechnology';

export interface TypeBlockSlideshowFields {
    internalName?: EntryFieldTypes.Symbol;
    overline?: EntryFieldTypes.Symbol;
    headerText?: EntryFieldTypes.Text;
    button?: EntryFieldTypes.EntryLink<TypeButtonSkeleton>;
    contentType?: EntryFieldTypes.Symbol<'Case studies' | 'Journal'>;
    entries?: EntryFieldTypes.Array<
        EntryFieldTypes.EntryLink<
            TypeBlockClientTestimonialSkeleton | TypePageCaseStudySkeleton | TypePageJournalSkeleton
        >
    >;
    solution?: EntryFieldTypes.EntryLink<TypeSolutionSkeleton>;
    service?: EntryFieldTypes.EntryLink<TypeServiceSkeleton>;
    technology?: EntryFieldTypes.EntryLink<TypeTechnologySkeleton>;
    companyTopic?: EntryFieldTypes.EntryLink<TypeCompanyTopicSkeleton>;
    industry?: EntryFieldTypes.EntryLink<TypeIndustrySkeleton>;
}

export type TypeBlockSlideshowSkeleton = EntrySkeletonType<TypeBlockSlideshowFields, 'blockSlideshow'>;
export type TypeBlockSlideshow<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockSlideshowSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockSlideshow<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockSlideshow<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockSlideshow';
}
